<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg8 xl5 px-2  slot="content" >
            <h4>Beheer uw assets met groepen</h4>
            <p>Wanneer u er voor kiest om uw assets te groeperen, dan kunt u eenvoudig uw groepen selecteren in rapportages, 
              herkennen aan specifieke iconen op de kaarten en zelfs per groep instellen hoe duidelijk deze zichtbaar dienen te zijn op de kaart doormiddel van het instellen van de markergrootte</p>
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
      
      <v-flex xs12 md12 lg12 xl8 pt-2>          
          <v-widget title="Assetgroepen beheren" class="" title-text-color="">
            <v-btn v-if="selectedAssetGroup" fab dark  color="accent" slot="button-top-right" @click="clearCurrent()">
                <v-icon dark>arrow_back</v-icon>
            </v-btn>                 
            <v-btn v-if="!selectedAssetGroup" fab dark  color="accent" slot="button-top-right" @click="newAssetGroup()">
                <v-icon dark>add</v-icon>
            </v-btn>           
            <v-layout slot="widget-content">
    <!---- GROUP LIST -------------------------------------------------------->              
                  <v-flex xs12 sm12 lg12 v-if="!selectedAssetGroup">
                    <v-card-text>
                    <v-list dense> 
                      <v-list-tile active-class="primary darken-2" @click="loadForm(group)" avatar v-for="group of assetGroups" :key="group.id">
                          <v-list-tile-avatar> <i :class="`${showIcon(group.icon)} fa-1x primary--text text--lighten-2`"></i>  </v-list-tile-avatar>                      
                          <v-list-tile-title v-html="group.name"></v-list-tile-title>                                            
                      </v-list-tile>                  
                    </v-list>                
                    </v-card-text>
                  </v-flex>
    <!---- GROUP DETAILS -------------------------------------------------------->                  
                  <v-flex  v-if="selectedAssetGroup" px-3 py-3> 
                    <v-tabs v-model="selectedTab" grow>
                      <v-tab key="group_form">Groepvelden</v-tab>
                      <v-tab key="extra_fields" @click="loadExtraFieldView" :disabled="!selectedAssetGroup.id">Extra velden</v-tab>
                      <v-tab key="poi" :disabled="!selectedAssetGroup.id" >Point of interests op groep</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="selectedTab">
              <!-- FORM TAB --------------------------------------------------------->
                      <v-tab-item key="group_form">                    
                        <v-form
                          mt-2
                          ref="form"
                          v-model="valid"
                          lazy-validation>
                          <v-flex>                                    
                            <v-text-field
                              v-model="selectedAssetGroup.name"                     
                              label="Naam"
                              :rules="nameRules"
                              required
                            ></v-text-field>
                            <v-select
                              :items="markerShapes"
                              item-value="key"
                              item-text="label"          
                              label="Vorm van marker"
                              v-model="selectedAssetGroup.shape"
                            ></v-select>                            
                            <icon-picker v-model="selectedAssetGroup.icon"></icon-picker>
                            <v-flex>
                              <v-subheader class="pl-0">Markergrootte</v-subheader>
                              <v-slider
                                v-model="selectedAssetGroup.markerSize"   
                                :thumb-size="20"                  
                                thumb-label="always"
                                min="12"
                                max="70"
                              ></v-slider>
                            </v-flex>                      
                          </v-flex>
                          <v-flex row >                  
                            <v-layout >
                              <v-btn                          
                                  color=""                      
                                  @click="clearCurrent"> 
                                  annuleren
                                </v-btn>                                                                                                         
                                <v-spacer></v-spacer>
                                <v-btn                                                
                                  color="error"
                                  :disabled="!selectedAssetGroup.canBeDeleted"
                                  @click="deleteGroup"> 
                                  Verwijder
                                </v-btn>                                           
                                <v-btn                                                
                                  :disabled="!valid"
                                  color="success"
                                  @click="saveForm">
                                  Opslaan
                                </v-btn>                        
                            </v-layout>                                                                    
                          </v-flex>                 
                        </v-form>
                     </v-tab-item>
          <!--- EXTRA DATA ------------------------------------------------------------------------->                     
                     <v-tab-item key="extra_fields">
                        <v-layout row wrap mt-4>
                            <v-flex xs12 md6 mb-4>
                                  <v-flex>
                                    <tool-tip-icon text="U kunt geselecteerde extra velden van volgorde veranderen</br> door ze naar boven/beneden te slepen en daarna op te slaan"></tool-tip-icon>                                                                                                             
                                    Geselecteerde extra velden voor {{selectedAssetGroup.name}}
                                  </v-flex>
                                  <draggable v-model="selectedCustomFields">
                                    <transition-group>
                                      <v-flex v-for="field of selectedCustomFields" :key="field.id" pl-3>
                                        <v-chip label style="padding-right:4px">
                                            <v-icon left >label</v-icon>
                                            <label>{{field.name}} ({{field.type.name}})</label>
                                            <v-icon class="fas fa-times" @click="removeFieldFromGroup(field)" right></v-icon>                 
                                        </v-chip>                                                                                                                                       
                                      </v-flex>
                                    </transition-group>
                                  </draggable>
                                  <v-flex v-if="selectedCustomFields.length==0" pl-4>
                                    <i>Geen extra velden geselecteerd voor deze groep</i>
                                  </v-flex>
                            </v-flex>                                                  
                            <v-flex xs12 md6>
                                <v-layout column>
                                  <v-flex mb-1> 
                                    <tool-tip-icon text="Klik op een beschikbaar extra veld om deze toe te voegen aan geselecteerde extra velden </br> Sla deze daarna op om uw wijzigingen door te voeren"></tool-tip-icon>
                                    Beschikbare extra velden:
                                  </v-flex>      
                                  <v-flex pl-3>                                                                      
                                    <v-text-field                      
                                        @keyup="searchCustomFields(compObj)"
                                        v-model="searchText"
                                        prepend-inner-icon="fas fa-search"
                                        dense
                                        label="Zoek een extra veld die u wilt voegen"
                                        solo                                      
                                    >                                                          
                                    </v-text-field>                                                           
                                  </v-flex>
                                  <v-dialog v-model="newCustomFieldDialog" persistent max-width="600">
                                    <v-flex pl-3 slot="activator">
                                      <v-chip label outline color="green">
                                        <v-icon left class="fas fa-plus" color="green" @click="addNewCustomField()"></v-icon> Nieuw extra veld aanmaken
                                      </v-chip>  
                                    </v-flex>
                                    <v-card>
                                      <v-card-title class="headline">Nieuw extra veld toevoegen</v-card-title>
                                      <v-card-text>
                                        <custom-field-form
                                          newOnSave="1"
                                          @saved="customFieldSaved"
                                          @cancelClicked="customFieldCanceled"
                                        >
                                        </custom-field-form>
                                      </v-card-text>
                                      <v-card-actions>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>                                      
                                  <v-flex v-for="field of unselectedCustomFields" :key="field.id" pl-3 >
                                    <v-chip label outline @click="addCustomField(field)">
                                      <v-icon left>label</v-icon>
                                        {{field.name}} ({{field.type.name}})
                                    </v-chip>                                                                                                                                       
                                  </v-flex>     
                                  <v-pagination
                                      v-model="customFieldsPagination.current_page"
                                      :length="customFieldsPagination.total_pages"                           
                                      @input="loadPage">
                                  </v-pagination>                                                                 
                                </v-layout>
                            </v-flex>       
                       </v-layout>                 
                      <v-layout row mt-4>
                        <v-btn                          
                            color=""                      
                            @click="clearCurrent"> 
                            annuleren
                          </v-btn>                                                                                                         
                          <v-spacer></v-spacer>                                         
                          <v-btn                                                
                            color="success"
                            @click="saveCustomFieldsOnGroup">
                            Opslaan
                          </v-btn>                        
                      </v-layout>                                                                                            
                     </v-tab-item>
              <!-------------- POI on GROUP ----------------------------------------------------------------------------------------->                     
                     <v-tab-item  key="poi"> 
                      
                        <asset-group-geo-zone-events v-if="selectedAssetGroup.id" :assetGroup="selectedAssetGroup"></asset-group-geo-zone-events>    
                        <v-flex xs12>
                          <v-layout>
                            <v-spacer></v-spacer> 
                            <v-btn @click="newPoiDialog=true" color="accent">Maak nieuwe POI koppeling voor {{selectedAssetGroup.name}}</v-btn>
                          </v-layout>
                        </v-flex>
                     </v-tab-item>
                  </v-tabs-items>
                </v-flex>                                                  
            </v-layout>
          </v-widget>
        </v-flex>           
    </v-layout>
    <!--- ADD GEOZONE EVENT ON ASSETGROUP POPUP ------------------------------------------------------------->
    <v-dialog  persistent v-model="newPoiDialog"  v-if="newPoiDialog">     
        <v-card>
            <v-card-title :class="`modal-title-bar`" >
                <h4>Point of interest op assetgroep {{selectedAssetGroup.name}}</h4>
                <v-spacer></v-spacer>
                <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closePoiWizard()"></i>                                
            </v-card-title>                        
        </v-card>       
        <poi-wizard :assetGroup="selectedAssetGroup" :assetGroupGeoZoneEvent="selectedAssetGroupGeoZoneEvent" @close="closePoiWizard()" @isSaved="poiCreated()"></poi-wizard>
    </v-dialog>    
  </v-layout>
</template>
<script>

import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import DdPage from '../../components/global/DdPage'
import VWidget from "../../components/global/VWidget"
import TopInfoPanel from '../../components/global/TopInfoPanel'
import IconPicker from '../../components/form/IconPicker'
import customFieldForm from '../../components/customFields/CustomFieldForm'
import ToolTipIcon from '../../components/global/ToolTipIcon'
import AssetGroupGeoZoneEvents from '../../components/asset/AssetGroupGeoZoneEvents'
import PoiWizard from '../../components/geozone/PoiWizard'

export default {
  components: {    
    PoiWizard,
    AssetGroupGeoZoneEvents,
    VWidget,
    DdPage,
    IconPicker,
    TopInfoPanel,
    customFieldForm,
    ToolTipIcon,
    draggable
  },
  data() {
    return  {
      newPoiDialog:false,
      selectedAssetGroupGeoZoneEvent:null,
      searchText:"",
      newCustomFieldDialog:false,
      selectedTab:0,
      selectedCustomFields:[],
      defaultIcon: "fas fa-question",
      valid:true,
      selectedAssetGroup:null,
      nameRules:[
        v => !!v || "Naam is verplicht"
      ]
    }
  }, 
  computed: {
    ...mapGetters({
      assetGroups: types.ASSET_GROUPS,
      allCustomFields: types.CUSTOM_FIELDS,
      customFieldsPagination: types.CUSTOM_FIELDS_PAGINATION,
      markerShapes:types.HD_MARKER_SHAPES
    }),
    unselectedCustomFields(){

      let result = []
      let selected = this.selectedCustomFields
      let selectable = this.allCustomFields
      
      selectable.forEach( (s1) => {        
          let found = false
          selected.forEach( (s2) => {        
              if(s1.id == s2.id){
                found = true
              }
          })
          if(!found){
            result.push(s1)
          }
      })
      return result
    }
  },
  methods: {
    saveForm(){
      if (this.$refs.form.validate()) {
          
          this.$store.dispatch(types.SAVE_ASSET_GROUP, {data:this.selectedAssetGroup} ).then((res) => {              
              // reload list after save         
              this.$notify(`Assetgroep ${this.selectedAssetGroup.name} is opgeslagen`, {color:'success', timeout: 4000, icon:'check'})               
              this.$store.dispatch(types.ASSET_GROUPS,{params:{per_page:200}}).then(() => {                                    
                  //this.selectedAssetGroup = this.assetGroups.find( (item) => item.id == res.id)
                  this.clearCurrent();
              })              
          })          
      }      
    },
    closePoiWizard(){
      this.newPoiDialog=false
    },
    poiCreated(){
      this.closePoiWizard()
      this.selectedAssetGroup=null
    },
    saveCustomFieldsOnGroup(){
       let i=0
       let saveFields=[]

       this.selectedCustomFields.forEach((field) => {
          saveFields.push({custom_field_id:field.id, sort_order:i})
          i++
       })
       this.$store.dispatch(types.SAVE_CUSTOM_FIELDS_ON_ASSET_GROUP, {data:{assetGroupId:this.selectedAssetGroup.id,customFields:saveFields}} ).then((res) => {                        
              
          // reload list after save  
          this.$notify("Extra velden op assetgroep "+this.selectedAssetGroup.name+" zijn aangepast", {color:'success', timeout: 4000, icon:'check'})                             
          this.loadAssetGroups()    
          this.clearCurrent()
       })
    },
    loadForm(assetGroup){
      let temp = {}
      Object.assign(temp, assetGroup)
      this.selectedAssetGroup = temp
    }, 
    deleteGroup(){
        this.$store.dispatch(types.DELETE_ASSET_GROUP, {data:{id:this.selectedAssetGroup.id}} ).then(() => {
          this.$store.dispatch(types.ASSET_GROUPS,{params:{per_page:200}})
          this.clearCurrent();
        })      
    },
    clearCurrent(){
      this.selectedTab=0
      this.selectedAssetGroup = null    
      this.selectedCustomFields=[]
      //this.$refs.form.reset()
    },
    newAssetGroup(){
      this.selectedAssetGroup = {id:"",
                                 name:"",
                                 icon:"",
                                 shape:"",
                                 markerSize:16,
                                 creationDate:"",
                                 lastChange:""}  
     // this.$refs.form.resetValidation()
    },
    showIcon(icon){
        if(icon.length != "")
          return icon

        return this.defaultIcon
    },
    loadExtraFieldView(){
      this.loadExtraFields()
      this.selectedCustomFields=[]
      Object.assign(this.selectedCustomFields, this.selectedAssetGroup.customFields)	
      this.sortSelectedCustomFields()
    },
    loadExtraFields(force=false){
      if(this.allCustomFields.length == 0 || force){
        this.$store.dispatch(types.CUSTOM_FIELDS,{params:{include:"type"}});
      }
    },
    addCustomField(field){
       this.selectedCustomFields.push(field)
    },
    addNewCustomField(){
      this.newCustomFieldDialog = false;
    },
    removeFieldFromGroup(removeField){
      let result = []
      this.selectedCustomFields.forEach((field) => {
          if(field.id != removeField.id){
            result.push(field)        
          }
      })
      this.selectedCustomFields = result
    },
    customFieldSaved(){
        this.loadExtraFields(true);
        this.newCustomFieldDialog=false;
    },
    customFieldCanceled(){
      this.newCustomFieldDialog=false
    },
    sortSelectedCustomFields(){
        let sortOrder = (a,b) => {
          if (a.sort_order < b.sort_order)
              return -1;
          if (a.sort_order > b.sort_order)
              return 1;
          return 0;            
        }        
        this.selectedCustomFields.sort(sortOrder)
    },
    loadAssetGroups(){
      this.$store.dispatch(types.ASSET_GROUPS,{params:{per_page:200,include:"customFields,customFields.type"}});
    },
    loadPage(pageNr, fromDebounce=false){                
        // first set the current page
        this.currentPage=pageNr;
        
        // if entered from search and charlength is 1 or 2 do nothing
        if(fromDebounce && this.searchText.length == 1 || fromDebounce && this.searchText.length == 2){
            return;
        }
        // if entered from search and charlength is 0 reload all custom fields
        else if(fromDebounce && this.searchText.length == 0){
            this.$store.dispatch(types.CUSTOM_FIELDS, {params:{page:pageNr, include:"type"}})                
        }                
        // if searchlength is more then 2 always use search (so pagination works on search)
        else if(this.searchText.length > 2){
            this.$store.dispatch(types.CUSTOM_FIELD_SEARCH, {data:{value:this.searchText},params:{page:pageNr, include:"type"}})
        }
        // default... pagination on all custom fields
        else{
            this.$store.dispatch(types.CUSTOM_FIELDS, {params:{page:pageNr, include:"type"}} ) 
        }                    
    },
    searchCustomFields: _.debounce( (compObj)=>{    
        compObj.loadPage(1, true);
    },300),                        
    loadCustomFields(){
        this.$store.dispatch(types.CUSTOM_FIELDS,{params:{include:"type"}}).then(() => { })                              
    }      
  },
  mounted() {
    this.clearCurrent();
    this.loadAssetGroups();

    this.$store.dispatch(types.CURRENT_BREADCRUMBS, [
      {text: 'Home', href: '/', disabled: false},
      {text: 'Instellingen', href: '/settings', disabled: false},
      {text: 'Asset groepen', href: '/settings/asset-groups', disabled: false},
      // {text: 'FLU0000001', disabled: true},
    ])
    this.$store.dispatch(types.BACKGROUND_ICON, 'cogs');
  },  
  beforeDestroy(){
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }
}
</script>
<style>
.dd-detail-list li{
  list-style-type: none;
  padding-bottom: 4px;
  padding-left: 4px;
  border-bottom: 1px solid black;
  background-color: blue-gey lighten-5;
}
</style>
